document.querySelectorAll('script[src*="temi-header.js"]').forEach((scriptTag) => {
  const sectionId = scriptTag.dataset.sectionId;
  const burger = document.getElementById(`temi-burger-${sectionId}`);
  const menu = document.getElementById(`temi-mobile-menu-${sectionId}`);
  const closeBtn = document.getElementById(`temi-mobile-menu-close-${sectionId}`);

  if (!burger || !menu || !closeBtn) return;

  function openMenu() {
    menu.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  burger.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);

  // Let the browser navigate natively on link taps, then close the overlay
  // on a short delay — hiding it synchronously would cancel the navigation.
  menu.addEventListener('click', (event) => {
    if (!event.target.closest('a')) return;
    setTimeout(closeMenu, 150);
  });
});
